module.exports = {"layout":"page","path":"/None","body":"<img src=\"nothing.jpg\" width=\"300\">\n"}


//////////////////
// WEBPACK FOOTER
// ./pages/None/index.md
// module id = 509
// module chunks = 0